angular.module('ics')

    .factory('ReportEmailTemplatesService', function ($http) {

        return {

            getReportEmailTemplatesList: function (firebaseTokenId, visitorId) {

                let req = {
                    method: 'GET',
                    url: '/api/report_email_template/list',
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000
                };

                return $http(req);


            },

            createReportEmailTemplate: function (templateName, emailSubject, emailBody, firebaseTokenId, visitorId) {
                let req = {
                    method: 'POST',
                    url: '/api/report_email_template/',
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000,
                    data: {
                        'template_name': templateName,
                        'email_body': emailBody,
                        'email_subject': emailSubject
                    }
                };

                return $http(req);
            },

            editReportEmailTemplate: function (emailTemplateId, templateName,
                                            emailSubject, emailBody, firebaseTokenId, visitorId) {
                let req = {
                    method: 'PUT',
                    url: `/api/report_email_template/${emailTemplateId}`,
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000,
                    data: {
                        'template_name': templateName,
                        'email_body': emailBody,
                        'email_subject': emailSubject
                    }
                };

                return $http(req);
            },

            deleteReportEmailTemplate: function (emailTemplateId, firebaseTokenId, visitorId) {
                var req = {
                    method: 'DELETE',
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    url: `/api/report_email_template/${emailTemplateId}`,
                    timeout: 8000
                };

                return $http(req);
            }
        }

    });
